<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Item Grouping 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
        <b-card no-body>
          <template v-slot:header>          
            <b-row v-if="(filterShow=='Hide')">
              <b-col lg="5">
                  <b-input-group size="sm" class="ml-1">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
              <b-col lg="7">
                  <b-input-group size="sm" >
                      <b-input-group-prepend > <span class="p-1">Filter On:</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="kodegroup">Group Code</b-form-checkbox>
                        <b-form-checkbox value="namagroup">Group Name</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-input-group-prepend > 
                          <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
                      </b-input-group-prepend>
                  </b-input-group>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>



          </template>
        <b-table
          class="mb-0"
          ref="table"
          outlined  responsive hover small
          style="font-size:smaller;" 
              :items="itemgroups"
              :fields="tblData.fields"
              :current-page="tblData.page"
              :per-page="tblData.limit"
              :sort-by.sync="tblData.sortBy"
              :sort-desc.sync="tblData.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"                
              @row-clicked="rowClicked"
        >
          <template v-slot:cell(nomor)="data">
            {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
          </template>
          <template v-slot:cell(kodegroup)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.kodegroup" style="font-weight:bold;" :style="`margin-left:${data.item.level*5}px`"></span>
            <span v-else v-html="data.item.kodegroup" :style="`margin-left:${data.item.level*5}px`"></span>
          </template>
          <template v-slot:cell(namagroup)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.namagroup" style="font-weight:bold;" :style="`margin-left:${data.item.level*5}px`"></span>
            <span v-else v-html="data.item.namagroup" :style="`margin-left:${data.item.level*5}px`"></span>
          </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
        </b-table>

        <b-row class="mt-2">
            <b-col cols="4">
              <div class="ml-1">
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries,   <span class="mr-1">limit per page :</span> 
              <input type="number" style="width:80px;" v-model="limit"/>
              </div>
            </b-col>
            <b-col cols="4">            
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-col>
            <b-col cols="4">            
              <b-pagination  class="ml-1" 
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
        </b-row>
        </b-card>

    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Master Item Group - Add/Edit Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
      <b-row >
          <b-col class="pr-4" cols="6">
              <b-form-group  label-cols=3  label="Group Code" >
                  <b-form-input v-model="frmdata.kodegroup" :state="!$v.frmdata.kodegroup.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Group Name" >
                  <b-form-input v-model="frmdata.namagroup" :state="!$v.frmdata.namagroup.$error"></b-form-input>
              </b-form-group>
          </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import item from "../../apis/item";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        kodegroup: { required },
        namagroup: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{kodegroup: '',namagroup: '' },
      filterShow:'Show',
      filter:null,
      filterOn: [],
      itemgroups:[],
      limit:20,
      tblData: {
        page: 1,
        fields:[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "kodegroup",
            label: "Group Code",
            sortable: true
          },
          {
            key: "namagroup",
            label: "Group Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ],
        limit: 20,
        total: 0,
        sortBy: 'kodegroup',
        sortDesc: false,
      },
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },   
  created: async function(){
     this.data();
  },    
  methods: {
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.filterOn= []   
      this.filter= '';   
    },
    data: async function(ctx) {
      this.itemgroups = await item.cataloggroup();    
      this.tblData.total = this.itemgroups.length;

    },
    refresh(ctx) {
      if (this.$refs.table) {
        this.data();
        this.$refs.table.refresh();
        }
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idstore) {
                await crud.update(
                     {tablename:'itemgroup', 
                     key:this.frmdata.idgroup, 
                     data:{kodegroup:this.frmdata.kodegroup,
                          namagroup:this.frmdata.namagroup
                          }
                      });
              } else {
                await crud.insert(
                  { tablename:'itemgroup',                      
                    data:{kodegroup:this.frmdata.kodegroup,
                          namagroup:this.frmdata.namagroup
                          }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'itemgroup', key:this.model.idgroup});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
